<div *ngIf="(usaProduct$ | async) as brandProduct">

    <!-- <pre>
        {{brandProduct | json}}
    </pre> -->

    <app-breadcrumb [title]="onTitle(brandProduct)" [category]="brandProduct.category"
        [subcategory]="brandProduct.subCategory" [brand]="brandProduct.subSubCategory"
        [breadcrumb]="'Product'|translate">
    </app-breadcrumb>


    <!-- section start -->
    <section class="section-b-space">
        <div class="collection-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="collection-filter" [class.openFilterbar]="mobileSidebar">
                            <div class="collection-filter-block">
                                <div class="collection-mobile-back" (click)="toggleMobileSidebar()">
                                    <span class="filter-back">
                                        <i class="fa fa-angle-left" aria-hidden="true"></i> {{'back'|translate}}
                                    </span>
                                </div>

                                <!-- <app-categories></app-categories> -->
                            </div>


                            <!-- <pre>
                                {{saleProducts|json}}
                            </pre> -->

                            <app-product-box-vertical-slider [title]="'Sale'|translate" [saleProducts]="saleProducts">
                            </app-product-box-vertical-slider>

                            <!-- service -->
                            <!-- <div class="collection-filter-block">
                                <app-services></app-services>
                            </div> -->


                        </div>
                    </div>
                    <div class="col-lg-9 col-sm-12 col-xs-12">
                        <div class="container-fluid">
                            <div class="row">

                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <owl-carousel-o [options]="ProductDetailsMainSliderConfig" #owlCar
                                        class="product-slick">
                                        <ng-container *ngFor="let image of brandProduct?.images; index as i">
                                            <ng-template carouselSlide [id]="i">
                                                <div>
                                                    <img [defaultImage]="'assets/images/product/placeholder.jpg'"
                                                        [lazyLoad]="image" class="img-fluid cropped">
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                    </owl-carousel-o>

                                    <div class="col-12 p-0" *ngIf="brandProduct?.images.length > 1">

                                        <div class="slider-nav">
                                            <owl-carousel-o [options]="ProductDetailsThumbConfig" class="product-slick">
                                                <ng-container *ngFor="let image of brandProduct?.images; index as i">
                                                    <ng-template carouselSlide [id]="i">
                                                        <div class="owl-thumb" [class.active]="i == activeSlide">
                                                            <img [defaultImage]="image" [lazyLoad]="image.src"
                                                                [alt]="image.alt" class="croppedNav"
                                                                (click)="owlCar.to(activeSlide = i.toString())">
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                            </owl-carousel-o>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 rtl-text">
                                    <div class="product-right">
                                        <h4> <span style="font-size: 15px; cursor: pointer;margin-left: -8px"
                                                [routerLink]="['/shop/product']" [queryParams]="
                                            {
                                                searchTerm:brandProduct?.brandName
                                            }">{{ brandProduct?.brandName}}</span>
                                        </h4>

                                        <h6 style="margin-left: -5px;">{{ brandProduct?.productName }}</h6>
                                        <h6 style="margin-left: -5px;">{{'Item number'|translate}}: {{
                                            brandProduct?.itemNumber }}</h6>
                                        <h6 style="margin-left: -5px;"
                                            *ngIf="brandProduct?.weight && brandProduct?.weight !='null'">
                                            {{'Weight'|translate}}: {{ brandProduct?.weight }}</h6>
                                        <h6 style="margin-left: -5px;"
                                            *ngIf="brandProduct?.color && brandProduct?.color !='null'">
                                            {{'Color:'|translate}} {{ brandProduct?.color }}</h6>
                                        <h6 style="margin-left: -5px;"
                                            *ngIf="brandProduct?.size && brandProduct?.size !='null'">
                                            {{'Size:'|translate}} {{ brandProduct?.size }}</h6>
                                        <h4>
                                            <del *ngIf="brandProduct.newPrice>0 || brandProduct.wholeSalePrice>0">
                                                <span>{{ brandProduct?.unitPrice |currency:
                                                    productService.Currency?.currency:'symbol' }}</span>
                                            </del>
                                        </h4>
                                        <h3>
                                            {{ (brandProduct?.newPrice | discount:brandProduct) | currency:
                                            productService.Currency?.currency:'symbol' }}
                                        </h3>


                                        <div *ngIf="!noColor">
                                            <ul class="color-variant" *ngIf="brandProduct.productVariations">
                                                <li *ngFor="let productVariation of brandProduct.productVariations; index as i"
                                                    [class]="productVariation.childColorName"
                                                    [class.active]="activeSlide == i.toString()"
                                                    [style]="setStyle(productVariation.childColorName)"
                                                    [ngStyle]="{'background-color': productVariation.childColorName,'border-color':activeSlide == i.toString()?'red':''}"
                                                    (click)="onColorClick(owlCar.to(activeSlide = i.toString()),productVariation.indexProductColorChildrenSizeDtos)">
                                                </li>

                                            </ul>

                                        </div>


                                        <table
                                            *ngIf="isWholeSaleAccount =='True' && brandProduct.setWholeSaleNumber1>0">
                                            <thead>
                                                <th>{{'Wholesale Price'|translate}} </th>
                                                <th style="margin-left: 35px;">{{'Price'|translate}}</th>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        1- {{brandProduct.setWholeSaleNumber1}}
                                                    </td>
                                                    <td style="margin-left: 35px;">
                                                        {{brandProduct.wholeSalePrice1| currency:
                                                        productService.Currency?.currency:'symbol' }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        >= {{brandProduct.setWholeSaleNumber1+1}}
                                                    </td>
                                                    <td>
                                                        {{brandProduct.wholeSalePrice2| currency:
                                                        productService.Currency?.currency:'symbol' }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <app-stock-inventory [stock]="brandProduct.quantity">
                                        </app-stock-inventory>

                                        <div class="product-description border-product">

                                            <div *ngIf="!noSize">
                                                <h6 class="product-title size-text"
                                                    *ngIf="brandProduct.productVariations">
                                                    {{'select size'|translate}}
                                                </h6>

                                                <div class="size-box" *ngIf="brandProduct.productVariations">
                                                    <ul>
                                                        <li *ngFor="let size of uniqSize"
                                                            [class.active]="currentBarcodeInAddressBar == size.barcode"
                                                            [ngStyle]="{'background-color':currentBarcodeInAddressBar == size.barcode?'#ff000036':''}">
                                                            <a (click)="selectSize(size)">
                                                                {{ size.sizeName | titlecase }}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                            <h5 class="avalibility" *ngIf="counter <= product.quantity"><span>In
                                                    Stock</span></h5>
                                            <h5 class="avalibility" style="margin-top: 30px;"
                                                *ngIf="counter > brandProduct.quantity"><span>{{'SOLD
                                                    OUT'|translate}}</span></h5>
                                            <!-- <h6 class="product-title" style="margin-top: 10px;" *ngIf="brandProduct.quantity>1">{{brandProduct.quantity}} quantities</h6>
                                            <h6 class="product-title" style="margin-top: 10px;" *ngIf="brandProduct.quantity<=1"> {{brandProduct.quantity}} quantity</h6> -->
                                            <div class="qty-box">
                                                <div class="input-group">
                                                    <span class="input-group-prepend">
                                                        <button type="button" class="btn quantity-left-minus"
                                                            data-type="minus" (click)="decrement()">
                                                            <i class="ti-angle-left"></i>
                                                        </button>
                                                    </span>
                                                    <input type="text" name="quantity" #addToCartQuantity
                                                        class="form-control input-number" [value]="counter" disabled />
                                                    <span class="input-group-prepend">
                                                        <button type="button" class="btn quantity-right-plus"
                                                            data-type="plus" (click)="increment()">
                                                            <i class="ti-angle-right"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="product-buttons">
                                            <a class="btn btn-solid" [class.disabled]="counter > brandProduct.quantity"
                                                (click)="addToCart(brandProduct,addToCartQuantity.value)">{{'Add to
                                                cart'|translate}}</a>
                                            <!-- <a class="btn btn-solid" [class.disabled]="counter > brandProduct.quantity" (click)="buyNow(brandProduct)">buy now</a> -->
                                        </div>

                                        <div class="border-product">
                                            <h6 class="product-title">{{'product details'|translate}}</h6>
                                            <p>{{ brandProduct.description.substring(0, 200)+'...' }}</p>
                                        </div>

                                        <!-- share it -->
                                        <!-- <div class="border-product">
                                            <h6 class="product-title">share it</h6>
                                            <div class="product-icon">
                                                <app-social></app-social>
                                                <form class="d-inline-block">
                                                    <button class="wishlist-btn" (click)="addToWishlist(product)">
                                                        <i class="fa fa-heart"></i>
                                                        <span class="title-font">Add To WishList</span>
                                                    </button>
                                                </form>
                                            </div>
                                        </div> -->

                                        <!-- end time offer -->
                                        <!-- <div class="border-product">
                                            <app-countdown [date]="'Apr 21 2021'"></app-countdown>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section class="tab-product m-0">
                            <div class="row">
                                <div class="col-sm-12 col-lg-12">
                                    <ngb-tabset [type]="'tabs'" class="nav-material">
                                        <ngb-tab>
                                            <ng-template ngbTabTitle>{{'Description'|translate}}</ng-template>
                                            <ng-template ngbTabContent>
                                                <p>{{ brandProduct.description }}</p>
                                            </ng-template>
                                        </ngb-tab>
                                        <ngb-tab>
                                            <ng-template ngbTabTitle>{{'Video'|translate}}</ng-template>
                                            <ng-template ngbTabContent>

                                                <div class="mt-3 text-center" *ngIf="isHasYoutubeLink; else noVideo">
                                                    <iframe [src]="urlSafe" width="560" height="315"
                                                        allow="autoplay; encrypted-media" allowfullscreen></iframe>
                                                </div>
                                                <ng-template #noVideo>
                                                    <div class="mt-3 text-center">
                                                        <h1>{{'No Video'|translate}} </h1>
                                                    </div>
                                                </ng-template>
                                            </ng-template>
                                        </ngb-tab>


                                        <!-- <ngb-tab>
                                            <ng-template ngbTabTitle>Write Review</ng-template>
                                            <ng-template ngbTabContent>
                                                <form class="theme-form">
                                                    <div class="form-row">
                                                        <div class="col-md-12 ">
                                                            <div class="media">
                                                                <label>Rating</label>
                                                                <div class="media-body ml-3">
                                                                    <div class="rating three-star">
                                                                        <i class="fa fa-star"></i>
                                                                        <i class="fa fa-star"></i>
                                                                        <i class="fa fa-star"></i>
                                                                        <i class="fa fa-star"></i>
                                                                        <i class="fa fa-star"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label for="name">Name</label>
                                                            <input type="text" class="form-control" id="name" placeholder="Enter Your name" required>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label for="email">Email</label>
                                                            <input type="text" class="form-control" id="email" placeholder="Email" required>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <label for="review">Review Title</label>
                                                            <input type="text" class="form-control" id="review" placeholder="Enter your Review Subjects" required>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <label for="review">Review Title</label>
                                                            <textarea class="form-control" placeholder="Wrire Your Testimonial Here" id="exampleFormControlTextarea1" rows="6"></textarea>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <button class="btn btn-solid" type="submit">Submit YOur
                                                                Review</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </ng-template>
                                        </ngb-tab> -->


                                    </ngb-tabset>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>

        <app-related-product [usaProduct$]="usaProduct$" [type]="product?.type"></app-related-product>
    </section>

    <!-- <app-size-modal #sizeChart [product]="product"></app-size-modal> -->
    <!-- Section ends -->



</div>